// import { login } from '../util/login';
// import { sessionStorage } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';

/**
 * https://blog.grossman.io/how-to-write-async-await-without-try-catch-blocks-in-javascript/
 * @param  {[type]} promise [description]
 * @return {[type]}         [description]
 * 重新登录
 * @param error cgi错误，如果错误等于8598998000，需要重新登录
 * @return  true: 是否已执行重新登录操作  false: 页面弹框错误
 */
// function relogin(error) {
//     if (error.retcode === '8598998000') {
//         const reloginTimes = Number.parseInt(sessionStorage.getItem('reloginTimes'), 10) || 0;
//         if (reloginTimes >= 2) {
//             return false;
//         }
//         sessionStorage.setItem('reloginTimes', reloginTimes + 1);
//         login(false, true);
//         return true;
//     }
//     return false;
// }

export default to;